import React from "react";

const ProfileInfoSkeleton = () => {
  return (
    <div className="card shadow">
      <div className="card-header card-header d-flex justify-content-between align-items-center">
        <div
          className="shimmer"
          style={{ width: "150px", height: "24px" }}
        ></div>
        <div
          className="shimmer"
          style={{ width: "80px", height: "32px" }}
        ></div>
      </div>
      <div className="card-body p-4">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="mb-3 form-floating">
            <div
              className="shimmer"
              style={{ height: "48px", width: "100%" }}
            ></div>
          </div>
        ))}
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="shimmer"
            style={{ width: "100px", height: "40px" }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfoSkeleton;
